import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Pillars from "@/components/Pillars";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import About from "@/components/About";
import WhyOffshore from "@/components/WhyOffshore";
import Execution from "@/components/Execution";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((target) => {
    lenisRef.current?.scrollTo(target, { offset: -64 });
  }, []);

  return (
    <div className="min-h-screen bg-paper font-mono text-ink antialiased">
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Pillars />
        <EditorialMarquee />
        <Services />
        <Execution />
        <WhyOffshore />
        <About />
        <Contact />
      </main>
      <Footer onNavigate={scrollTo} />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
